import { AxiosResponse } from 'axios'
import { ELeadServiceStatus, ELeadServiceType } from 'containers/App/appLayoutEnum'
import { ISeller, IServiceBrand, IServiceLead } from 'containers/App/appLayoutTypes'

export enum ELeadServiceOrderBy {
  CREATED_AT_ASC = '+created_at',
  CREATED_AT_DESC = '-created_at',
  NAME_ASC = '+name',
  NAME_DESC = '-name',
}

export type TLeadServiceGetServicesParams = {
  type: ELeadServiceType
  order_by?: ELeadServiceOrderBy
  page?: number
  per_page?: number
  status?: ELeadServiceStatus
}

export type TIntegrationSelectionAvaible = {
  is_available: boolean
}

export type TSellerBrandsOptions = {
  name: string
}

export type TCreateLeadMinimalParams = {
  document: string
  channelId: string
  referralCode?: string
}

export interface ILeadService {
  get: (size?: number, per_page?: number, sellerId?: string[]) => Promise<AxiosResponse<ISeller[]>>
  getLead: (sellerId?: string[]) => Promise<AxiosResponse<ISeller>>
  getServices: (params: TLeadServiceGetServicesParams) => Promise<AxiosResponse<IServiceLead[]>>
  getIntegrationSelectionAvailable: (
    sellerId: string
  ) => Promise<AxiosResponse<TIntegrationSelectionAvaible>>
  getSellerBrandsOptions: (
    starting_with: string,
    service_id: string
  ) => Promise<AxiosResponse<IServiceBrand[]>>
  leadsAvailableChannel: (
    display_name: string,
    channelId?: string,
    document?: string
  ) => Promise<boolean>
  createLeadMinimal: (params: TCreateLeadMinimalParams) => Promise<AxiosResponse<ISeller>>
}
